import { render, staticRenderFns } from "./PendingLinksList.vue?vue&type=template&id=4a2e5154&"
import script from "./PendingLinksList.vue?vue&type=script&lang=js&"
export * from "./PendingLinksList.vue?vue&type=script&lang=js&"
import style0 from "./PendingLinksList.vue?vue&type=style&index=0&id=4a2e5154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports